import { Component } from '@theme/component';
import { redirectAddToCartToSizeDrawer } from '@theme/utilities';

/**
 * Wraps the PDP buy-box. Its only job today: when the product has selectable sizes and the
 * customer hasn't explicitly picked one yet, clicking "Ajouter au panier" opens the size drawer
 * instead of submitting the form (no disabled state, no error — cf.
 * .docs/product-page-integration.md décision 6). The click is not lost: picking a size in that
 * drawer completes the add, since the drawer only opened to answer it.
 */
class ProductBuyBox extends Component {
  /** @type {AbortController} */
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    if (this.#abortController.signal.aborted) {
      this.#abortController = new AbortController();
    }
    const { signal } = this.#abortController;

    // Delegated from the host, not bound on the button: a color swap morphs the whole section and
    // may replace the button node (cf. product-color-swap.js).
    this.addEventListener('click', this.#handleAddToCartClick, { signal, capture: true });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  /** @param {MouseEvent} event */
  #handleAddToCartClick = (event) => {
    const { target } = event;
    if (!(target instanceof Element) || !target.closest('[ref="addToCartButton"]')) return;

    if (redirectAddToCartToSizeDrawer(this)) {
      event.preventDefault();
      event.stopPropagation();
    }
  };
}

if (!customElements.get('product-buy-box')) {
  customElements.define('product-buy-box', ProductBuyBox);
}
